import { Injectable } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import * as globals from '../settings';

@Injectable()
export class JsontranslateService {
    versionToSend: any;
    brand = globals.brand;
    constructor(private translate: TranslateService, private http: HttpClient) {
        if (globals.version.length === 0) {
            this.versionToSend = "warningThisTextIsStaticCheckSettingsTS";
        } else {
            this.versionToSend = globals.version;
        }
    }

    loadTranslations(component: string, locale: string) {
        let file_location;
        if (this.brand === 'winaija') {
            file_location =  'en-winaija';
        } else {
            file_location = locale;
        }
        return this.http.get('assets/i18n/' + file_location + '/' + component + '-' + file_location + '.json?v=' + this.versionToSend).subscribe((data: any) => {
            this.translate.setTranslation(locale, data, true);
        });
    }
}
